import { UserTypeSelection } from '../../enums/user-type-selection.enum';

import { GrantRevokePermissionsState } from './grant-revoke-permissions.state';

export const GrantRevokePermissionsInitialState: GrantRevokePermissionsState = {
    accessFlowStepper: {
        isLoading: false,
        error: null,
        addUser: {
            selectedAccounts: [],
            selectedUserType: UserTypeSelection.EXISTING,
            selectedUser: null,
            selectedAccess: null,
            searchPersonAttemptCounter: 0,
        },
        editUser: null,
        removeUser: {
            selectedAccounts: [],
            selectedUser: null,
        },
        operationResponse: null,
        uniquePin: null,
    },
};
